import { render, staticRenderFns } from "./DisputePage.vue?vue&type=template&id=6a7093ca&scoped=true"
import script from "./DisputePage.vue?vue&type=script&lang=js"
export * from "./DisputePage.vue?vue&type=script&lang=js"
import style0 from "./DisputePage.vue?vue&type=style&index=0&id=6a7093ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7093ca",
  null
  
)

export default component.exports